import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function SiteFooter() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
                U
              </span>
              <span className="font-heading font-bold text-foreground-900 text-lg">
                {t("brand")}
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              {t("footer.disclaimer")}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-4">
              <a href="#categories" className="cursor-pointer">{t("nav.guide")}</a>
            </h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li>
                <Link to="/usfans-spreadsheet-guide" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  {t("nav.guide")}
                </Link>
              </li>
              <li>
                <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  {t("mainSite")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-4">
              {t("brandSub")}
            </h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                {t("footer.independent")}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>
                {t("footer.updated")}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line text-primary-500"></i>
                {t("footer.multilingual")}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {t("brand")}. {t("footer.rights")}
          </p>
          <p className="text-xs text-foreground-500">{t("footer.independent")}</p>
        </div>
      </div>
    </footer>
  );
}